import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import ResponsibleGamblingBanner from "./ResponsibleGamblingBanner";
import CookieBanner from "./CookieBanner";
import { MatchesTicker } from "./MatchesTicker";

export const Layout = ({ children }) => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname]);

    return (
        <div className="min-h-screen flex flex-col bg-background text-foreground transition-colors duration-300">
            <MatchesTicker />
            <Header />
            <main className="flex-1 pb-20 sm:pb-14" data-testid="main-content">
                {children}
            </main>
            <Footer />
            <ResponsibleGamblingBanner />
            <CookieBanner />
        </div>
    );
};

export default Layout;
